import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import store from "@/store";
import router from "@/router";
import NProgress from "nprogress";
import qs from "qs";
import { errorMessage } from "../message";


/**
 * 天侠网客服服务
 */
var instance = axios.create({
    timeout: 80000,
    headers: {
        "Content-Type": "application/json;charset=UTF-8;",
    },
});

instance.interceptors.request.use(
  (config: any) => {
    config.baseURL = process.env.VUE_APP_API_URL;
    NProgress.start();
    const token = store.state.token.access_token;
    config.headers["X-Authorization"] = "Bearer " + token;
    return config;
  },
  (error) => {
    NProgress.done();
    errorMessage("网络异常");
    Promise.reject(error);
  },
);

instance.interceptors.response.use(
  (response) => {
    NProgress.done();
    return response;
  },
  (error) => {
    NProgress.done();
    errorMessage("网络异常");
    return error.response;
  },
);

export const GET = (url: string, params?: any) => {
  return new Promise((resolve) => {
    instance.get(url, { params: params }).then((response) => {
      outErrorMsg(response);
      resolve(response.data);
    });
  });
};

export const postJSON = (url: string, params?: any) => {
  return new Promise((resolve) => {
    instance.post(url, params).then((response) => {
      outErrorMsg(response);
      resolve(response.data);
    });
  });
};

export const postFORM = (url: string, params?: any) => {
  return new Promise((resolve) => {
    let pars = qs.stringify(params);
    instance
      .post(url, pars, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
      .then((response) => {
        outErrorMsg(response);
        resolve(response.data);
      });
  });
};

export const upload = (url: string, formData: any) => {
  return new Promise((resolve) => {
    instance
      .post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        resolve(response.data);
      });
  });
};

/**
 * 天侠网聊天服务
 */
var chatInstance = axios.create({
  timeout: 80000,
  headers: {
    "Content-Type": "application/json;charset=UTF-8;",
  },
});

chatInstance.interceptors.request.use(
  (config: any) => {
    config.baseURL = process.env.VUE_APP_IM_URL;
    const token = store.state.chatToken.access_token;
    config.headers["X-Authorization"] = token;
    return config;
  },
  (error) => {
    errorMessage("网络异常");
    Promise.reject(error);
  },
);

chatInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    errorMessage("通信网络异常");
  },
);

export const postChatJson = (url: string, params?: any) => {
  return new Promise((resolve) => {
    chatInstance.post(url, params).then((response) => {
      if (response) resolve(response.data);
    });
  });
};

export const postChatFORM = (url: string, params?: any) => {
  return new Promise((resolve) => {
    let pars = qs.stringify(params);
    chatInstance
      .post(url, pars, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
      .then((response) => {
        if (response) resolve(response.data);
      });
  });
};
export const chatGET = (url: string, params?: any) => {
  return new Promise((resolve) => {
    chatInstance.get(url, { params: params }).then((response) => {
      if (response) resolve(response.data);
    });
  });
};

const outErrorMsg = (response: AxiosResponse<any, any>) => {
  if (response.data.status == 200) return;
  switch (response.data.status) {
    case 403:
      store.commit("LOGIN_OUT");
      router.push("/login");
      break;
    case 401:
      store.commit("LOGIN_OUT");
      router.push("/login");
      break;
    case 101:
      store.commit("LOGIN_OUT");
      router.push("/login");
      break;
    default:
      errorMessage(response.data.message);
      break;
  }
};
